import React from "react";

export default class PlaybackRateBtnGroup extends React.Component {
    constructor (props) {
        super(props);

        this.rates = [0.2, 0.5, 1, 3, 6];
        this.state = {rateIndex: 2};

        this.hotkeys = {
            "5": () => this.setRate(0),
            "6": () => this.setRate(1),
            "7": () => this.setRate(2),
            "8": () => this.setRate(3),
            "9": () => this.setRate(4),
        };
    }

    componentDidMount () {
        this.props.hotkeyHandler.subscribe(this.hotkeys, this);
    }

    componentWillUnmount () {
        this.props.hotkeyHandler.unsubscribe(this.hotkeys, this);
    }

    setRate (rateIndex) {
        this.setState({rateIndex: rateIndex});
        this.props.videoElement.playbackRate = this.rates[rateIndex];
    }

    render () {
        const btnClassName = "btn btn-transparent btn-default text-outline";
        const btns = this.rates.map((rate, idx) => (
            <a key={idx}
                className={idx===this.state.rateIndex ? btnClassName + " active" : btnClassName}
                onClick={() => this.setRate(idx)}>
                {rate.toString()}x
            </a>
        ));

        let style = this.props.style || {};

        return (
            <div className="transparent-black-bg" style={style}>
                <div className="btn-group btn-group-justified">
                    {btns}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/PlaybackRateBtnGroup.js